import { createSlice } from "@reduxjs/toolkit";


export const cartSlice = createSlice({
    name: 'cart',
    initialState: {
        cartlengthvalue: 0,
        cartlistdata: [],
        show: false,
        salesTax: ""
    },
    reducers: {
        cartlength: (state, action) => {
            state.cartlengthvalue = action.payload
        },
        cartlistdata: (state, action) => {
            state.cartlistdata = action.payload
        },
        showcartlist: (state, action) => {
            state.show = action.payload
        },
        saleTax: (state, action) => {
            state.salesTax = action.payload
        }
    }
})

export const { cartlength, cartlistdata, showcartlist,saleTax } = cartSlice.actions
export default cartSlice.reducer